import { Link, useParams, useNavigate, useAsyncError } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const ServiceSetting = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [products, setProducts] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    price: 0,
    servicePriceType: "",
    isTaxFree: true,
    enabled: true,
    beUsedInInvoice: true,
    description: "",
    baseProductId: 0,
    branchId: 0,
    code: ""
  });
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const getGridData = async () => {
    const resp = await apiMethod.getServices(filterModel.branchId, filterModel.size, filterModel.part, filterModel.title);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.findProducts(filterModel.branchId, "", "");
    if (methods.showApiErrors(resp1)) {
      setProducts(resp1.data);
    }

    const resp2 = await apiMethod.getServicePriceTypes();
    if (methods.showApiErrors(resp2)) {
      setServiceTypes(resp2.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.servicePriceType)) {
      errors.push('.تعریف در فروش باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.price = 0;
    formModel.servicePriceType = "";
    formModel.isTaxFree = true;
    formModel.enabled = true;
    formModel.beUsedInInvoice = true;
    formModel.description = "";
    formModel.baseProductId = 0;
    formModel.branchId = branchId;
    formModel.code = "";
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getServiceInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.price = resp.data.price;
    formModel.servicePriceType = resp.data.servicePriceType;
    formModel.isTaxFree = resp.data.isTaxFree;
    formModel.enabled = resp.data.enabled;
    formModel.beUsedInInvoice = resp.data.beUsedInInvoice;
    formModel.description = resp.data.description;
    formModel.baseProductId = resp.data.baseProductId;
    formModel.branchId = resp.data.branchId;
    formModel.code = resp.data.code;

    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createService(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const CheckboxStatusChange = async (product) => {
    setLoading(true);
    const resp = await apiMethod.enableService(product.id);
    if (methods.showApiErrors(resp)) {
      product.enabled = resp.data;
      setFormModel({ ...formModel, enabled: resp.data });
      await getGridData();
      setLoading(false);
    }
  };

  const CheckboxInvoiceChange = async (product) => {
    setLoading(true);
    const resp = await apiMethod.useInInvoice(product.id);
    if (methods.showApiErrors(resp)) {
      product.beUsedInInvoice = resp.data;
      setFormModel({ ...formModel, beUsedInInvoice: resp.data });
      await getGridData();
      setLoading(false);
    }
  };

  const handleProductChange = (event) => {
    const selectedProductId = parseInt(event.target.value);
    const selectedProduct = products.find(product => product.id === selectedProductId);
    if (selectedProduct) {
      setFormModel({
        ...formModel,
        baseProductId: selectedProductId,
        code: selectedProduct.code,
        title: selectedProduct.title,
      });
    } else {
      setFormModel({
        ...formModel,
        baseProductId: 0,
        code: "",
      });
    }
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#5`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#5`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                تنظیمات سرویس‌ها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>تنظیمات سرویس‌ها
                <a href={`/sale/${branchId}/softwareGuide/#section3`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="selectَProductToAdd your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>سرویس جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                {products.length === 0 ? (
                  <div className='my-5'>
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button className='btn btn-outline-purple' onClick={() => { navigate(`/baseinfo/${branchId}/product`) }}>افزودن خدمات</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <table className="table table-striped table-md " >
                      <thead className='align-middle'>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center">هزینه (ریال)</th>
                          <th scope="col vertical-center">معاف از مالیات</th>
                          <th scope="col vertical-center">مشاهده در فاکتور</th>
                          <th scope="col vertical-center">وضعیت</th>
                          <th scope="col vertical-center" width="100px">عملیات</th>
                        </tr>
                      </thead>
                      <tbody className='align-middle'>
                        {gridData.map((product, index) => (
                          <tr key={product.id}>
                            <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                            <td>{product.title}</td>
                            <td>{methods.addNumSeperator(product.price)}</td>
                            <td>
                              {product.isTaxFree ? <i className="bi bi-check-square fs-5 activeCheckbox"></i> : <i className="bi bi-x-square fs-5 inActiveCheckbox"></i>}
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={product.beUsedInInvoice}
                                value={product.beUsedInInvoice}
                                onChange={() => CheckboxInvoiceChange(product)}
                                className="visually-hidden"
                                id={`productInvoice-${product.id}`}
                              />
                              <label htmlFor={`productInvoice-${product.id}`}>
                                {product.beUsedInInvoice ? <i className="bi bi-check-square fs-5 activePagerCheckbox"></i> : <i className="bi bi-x-square fs-5 inActivePagerCheckbox"></i>}
                              </label>
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={product.enabled}
                                value={product.enabled}
                                onChange={() => CheckboxStatusChange(product)}
                                className="visually-hidden"
                                id={`productEnable-${product.id}`}
                              />
                              <label htmlFor={`productEnable-${product.id}`}>
                                {product.enabled ? <i className="bi bi-check-square fs-5 activePagerCheckbox"></i> : <i className="bi bi-x-square fs-5 inActivePagerCheckbox"></i>}
                              </label>
                            </td>
                            <td>
                              <button
                                onClick={() => editItem(product.id)}
                                className='btn btn-sm btn-outline-purple me-2' type='button'>
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              <button
                                onClick={() => selectَItemToDelete(product)}
                                className='btn btn-sm btn-outline-danger' type='button'>
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filterModel.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {makePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </>)}
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (product) => {
    setFormModel(product);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeService(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش سرویس</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label htmlFor="baseProductId" className="form-label">انتخاب خدمت</label>
                  <select
                    id="baseProductId"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.baseProductId}
                    onChange={(e) => { handleProductChange(e) }}
                  >
                    <option value="">انتخاب کنید</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.id}>
                        {product.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="baseProductId" className="form-label required-label">تعریف در فروش</label>
                  <select
                    id="baseProductId"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.servicePriceType}
                    onChange={(e) => {
                      formModel.servicePriceType = parseInt(e.target.value);
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {serviceTypes.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <label htmlFor="code" className="form-label">کد</label>
                  <input type="text" className="form-control" id="code" name="code"
                    value={formModel.code}
                    aria-label="readonly input example"
                    readOnly
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title" name="title"
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="price" className="form-label">هزینه (ریال)</label>
                  <input type="text" className="form-control" id="price" name="price"
                    value={methods.addNumSeperator(formModel.price)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const price = parseInt(inputValue.replace(/,/g, ''));
                      setFormModel({ ...formModel, price: isNaN(price) ? '' : price });
                    }}
                  />
                </div>
                <div className='col-md-4'>
                  <div className="form-check mt-2 mb-2">
                    <input
                      onChange={(e) => {
                        setFormModel({ ...formModel, isTaxFree: e.target.checked })
                      }}
                      checked={formModel.isTaxFree}
                      className="form-check-input" type="checkbox" id="chbenabled" />
                    <label className="form-check-label" htmlFor="chbenabled">
                      معاف از مالیات
                    </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-check mt-2 mb-2">
                    <input
                      onChange={(e) => {
                        setFormModel({ ...formModel, beUsedInInvoice: e.target.checked })
                      }}
                      checked={formModel.beUsedInInvoice}
                      className="form-check-input" type="checkbox" id="chbenabled" />
                    <label className="form-check-label" htmlFor="chbenabled">
                      نمایش در فاکتور
                    </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-check mt-2 mb-2">
                    <input
                      onChange={(e) => {
                        setFormModel({ ...formModel, enabled: e.target.checked })
                      }}
                      checked={formModel.enabled}
                      className="form-check-input" type="checkbox" id="chbenabled" />
                    <label className="form-check-label" htmlFor="chbenabled">
                      وضعیت
                    </label>
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="description" className="form-label">توضیحات</label>
                  <textarea type="text" className="form-control" id="description" name="description" rows={3}
                    value={formModel.description || ""}
                    onChange={(e) => { setFormModel({ ...formModel, description: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer d-inline-flex d-lg-flex">
              <button type="button" className="btn custome-btn btn-link-purple" onClick={closeModal}>
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-25"
                onClick={() => { createNewItem() }}
              >ذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={'سرویس'}
        />
      }
    </>
  );
}

export default ServiceSetting;